import React from "react";
import { useAuth } from "../AuthProvider";

export default function StockDetailSummaryBar({
  row,
  onAskAi,
  getTimingStatus,
  extractBuyRange,
  fmtPct,
  fmtFloor,
  getPctClass,
}) {
  const { token } = useAuth() || {};

  if (!row) return null;

  const authHeaders = () => {
    const h = {};
    if (token) h["Authorization"] = `Bearer ${token}`;
    return h;
  };

  const { label: timingLabel, className: timingClass } = getTimingStatus
    ? getTimingStatus(row)
    : { label: "-", className: "text-gray-300" };

  const [buyLow, buyHigh] = extractBuyRange
    ? extractBuyRange(row)
    : [null, null];

  const last = Number(row.last_price);
  const close = Number(row.price);

  let changePct = null;
  if (close && last) changePct = ((last - close) / close) * 100;

  return (
    <div className="mt-3 rounded-xl border border-gray-800 bg-gray-900/60 backdrop-blur px-3 py-3">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">

        {/* ===== Stats Section ===== */}
        <div className="grid grid-cols-2 gap-3 md:flex md:flex-wrap md:gap-4">

          <MiniStat
            label="Change%"
            value={
              changePct === null ? (
                <span className="text-gray-400">—</span>
              ) : (
                <span
                  className={
                    changePct > 0
                      ? "text-green-400"
                      : changePct < 0
                      ? "text-red-400"
                      : "text-gray-200"
                  }
                >
                  {changePct > 0 ? "+" : ""}
                  {changePct.toFixed(2)}%
                </span>
              )
            }
          />

          <MiniStat
            label="4W %"
            value={
              <span className={getPctClass ? getPctClass(row.chg_4w_pct) : "text-gray-200"}>
                {row.chg_4w_pct != null && fmtPct ? fmtPct(row.chg_4w_pct) : "-"}
              </span>
            }
          />

          <MiniStat
            label="13W %"
            value={
              <span className={getPctClass ? getPctClass(row.chg_13w_pct) : "text-gray-200"}>
                {row.chg_13w_pct != null && fmtPct ? fmtPct(row.chg_13w_pct) : "-"}
              </span>
            }
          />

          <MiniStat
            label="Suggest"
            value={row.suggest_pct != null && fmtPct ? fmtPct(row.suggest_pct) : "-"}
          />

          <MiniStat
            label="Signal"
            value={row.signal ?? "-"}
            valueClass={toneSignal(row.signal)}
          />

          <MiniStat
            label="Timing"
            value={<span className={timingClass}>{timingLabel}</span>}
          />

          <MiniStat
            label="Buy Range"
            value={
              buyLow != null && buyHigh != null && fmtFloor
                ? `${fmtFloor(buyLow)} - ${fmtFloor(buyHigh)}`
                : "-"
            }
          />

          <MiniStat
            label="TP1 / TP2"
            value={
              (row.tp1 || row.tp2) && fmtFloor
                ? `${fmtFloor(row.tp1)} / ${fmtFloor(row.tp2)}`
                : "-"
            }
          />

          <MiniStat label="R/R" value={row.rr != null ? row.rr : "-"} />

        </div>

        {/* ===== Ask AI Button ===== */}
        <div className="flex items-center justify-end">
          <button
            onClick={() => onAskAi?.(row)}
            className="px-3 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white font-semibold text-sm"
            title="Tanya Bot berdasar data saham ini"
          >
            Ask AI
          </button>
        </div>
      </div>
    </div>
  );
}

function MiniStat({ label, value, valueClass = "text-gray-200" }) {
  return (
    <div className="min-w-[140px]">
      <div className="text-[11px] uppercase tracking-wide text-gray-400">
        {label}
      </div>
      <div className={`text-sm font-semibold ${valueClass}`}>
        {value}
      </div>
    </div>
  );
}

function toneSignal(signal) {
  const s = String(signal || "").toUpperCase();
  if (s.includes("BUY")) return "text-emerald-200";
  if (s.includes("WATCH")) return "text-amber-200";
  if (s.includes("AVOID")) return "text-rose-200";
  return "text-gray-200";
}
